import React from 'react'
import type { ArticleUIData } from '@which/shared'

import classnames from 'classnames'

import { renderArticleElements } from './article-element-renderer'

export const articleBodyRenderer = (
  articleBodyTemplate: ArticleUIData[],
  additionalClasses = '',
  articleUrl?: string | undefined
) => (
  <div className={classnames('article-wrapper', additionalClasses)}>
    {renderArticleElements(articleBodyTemplate, articleUrl)}
  </div>
)
